import React, { useState,useEffect } from 'react';
import { 
  View, 
  Text, 
  FlatList, 
  StyleSheet, 
  TouchableOpacity, 
  Modal, 
  TextInput, 
  ActivityIndicator, 
  Alert 
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { useVehicles } from '../context/VehicleContext';
import CustomAlert from '../components/CustomAlert';
import WebModal from '../components/WebModal';

export default function HomeScreen() {

  const {vehicles, nakitToplam, kartToplam, personelOzetleri, verileriYenile, socketRef } = useVehicles();
  const [refreshing, setRefreshing] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);
  const [aracbilgisi, setaracbilgisi] = useState({
    Fiyat: 0,
    MusteriTuru: 1,
    IndirimTuru: 0,
    IndirimAdi : ""
  });

  const [loadingPrice, setLoadingPrice] = useState(false);
  const [paymentType, setPaymentType] = useState('Nakit');

  const [alertConfig, setAlertConfig] = useState({
  visible: false,
  title: '',
  message: '',
  type: 'info',
  onConfirm: () => {},
  showCancel: false
});

const [personelModalVisible, setPersonelModalVisible] = useState(false);


useEffect(() => {
    if (socketRef && socketRef.current) {
      
      const handleSocketHaberi = (gelenVeri) => {
        // Gelen mesaj türünü bir değişkene alalım ki kod daha okunaklı olsun
        const mesajTuru = gelenVeri?.data?.message;

        // EĞER mesaj "AddPlaka" YADA "DeletePlaka" ise içeri gir 
        if (mesajTuru === "AddPlaka" || mesajTuru === "DeletePlaka" || mesajTuru === "UpdatePlaka" || mesajTuru === "ReloadArabalar" || mesajTuru === "addplate" || mesajTuru === "deleteplate" || mesajTuru === "TahsilatIptal") {
          console.log(`✅ Socket tetiklendi (${mesajTuru}) - 2 saniye bekleniyor...`);
          
          setTimeout(() => {
            verileriYenile();
          }, 500); 
        }
      };

      // Dinleyiciyi başlat
      socketRef.current.on('senk', handleSocketHaberi);

      // Ekrana veda ederken dinleyiciyi temizle
      return () => {
        socketRef.current.off('senk', handleSocketHaberi);
      };
    }
  }, [socketRef, verileriYenile]);



  // --- FONKSİYONLAR ---
  const onRefresh = () => {
    setRefreshing(true);
    verileriYenile();
    setTimeout(() => {
      setRefreshing(false);
    }, 1000);
  };

  const handleLongPress = async (vehicle) => {
    if (vehicle.isPaid) {
        setAlertConfig({
          visible: true,
          title: "Hata",
          message: "Bu Aracın Ödemesi Alınmış. Tahsilat işlemi yapılamaz.",
          type: 'error', // Kırmızı hata ikonu
          showCancel: false,
          confirmText: "Tamam",
          onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false }))
        });
      return;
    }
    
    setSelectedVehicle(vehicle);
    setLoadingPrice(true);

    // Sunucudan fiyatı çek (Kendi API URL'ini kontrol et)
    try {
      const response = await fetch(
        "https://mirwax.durumrapor.com/app.php?action=GetPrice",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(vehicle),
        }
      );

      const data = await response.json();

      setaracbilgisi((prev) => ({
        ...prev,
        Fiyat: data?.price ?? 0,
        MusteriTuru: data?.MusteriTuru ?? prev.MusteriTuru,
        IndirimTuru: data?.IndirimTuru ?? prev.IndirimTuru,
        IndirimAdi: data?.IndirimAdi ?? prev.IndirimAdi,
      }));
      //console.log("Güncellenen aracbilgisi:", aracbilgisi);
      setPaymentModalVisible(true);
    } catch (error) {

      setPaymentModalVisible(false); // Ana tahsilat modalını kapat

      setAlertConfig({
          visible: true,
          title: "Hata",
          message: "Fiyat bilgisi alınamadı.",
          type: 'error', // Kırmızı hata ikonu
          showCancel: false,
          confirmText: "Tamam",
          onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false }))
        });

      console.log("Fiyat çekme hatası:", error);

      setaracbilgisi((prev) => ({
        ...prev,
        Fiyat: 0,
      }));
    } finally {
      setLoadingPrice(false);
    }

  };

  const handlePersonelTahsilat = (personelAd, odemeTuru) => {
  // O personele ait tahsil edilecek araçları bul
  const hedefAraclar = vehicles.filter(
    (v) =>
      v.personnel === personelAd &&
      v.RemoteTahsilat === 'OK' &&
      v.isPaid === false &&
      v.OdemeTuru === odemeTuru
  );

  if (hedefAraclar.length === 0) {
    setAlertConfig({
      visible: true,
      title: 'Uyarı',
      message: `${personelAd} için bekleyen ${odemeTuru === 'NAKİT' ? 'nakit' : 'kart'} tahsilat yok.`,
      type: 'warning',
      showCancel: false,
      confirmText: 'Tamam',
      onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false })),
    });
    return;
  }

  const tutar = personelOzetleri[personelAd]?.[odemeTuru === 'NAKİT' ? 'nakit' : 'kart'] || 0;

  setAlertConfig({
    visible: true,
    title: 'Tahsilat Onayı',
    message: `*${personelAd}* personelinin *${hedefAraclar.length} araç* için toplam *${formatCurrency(tutar)}* ${odemeTuru === 'NAKİT' ? 'nakit' : 'kart'} tahsilatı alınacak.\n\nOnaylıyor musunuz?`,
    type: 'info',
    showCancel: true,
    confirmText: 'Evet, Tahsil Et',
    cancelText: 'Vazgeç',
    onConfirm: async () => {
      setAlertConfig(prev => ({ ...prev, visible: false }));
      await executePersonelTahsilat(hedefAraclar);
    },
  });
};

  const executePersonelTahsilat = async (hedefAraclar) => {
    try {
      const tarih = new Date().toLocaleString('sv-SE').replace('T', ' ');

      // Tüm araçlar için CompletePayment isteği gönder
      await Promise.all(
        hedefAraclar.map(async (vehicle) => {
          // Önce fiyatı çek
          const priceRes = await fetch('https://mirwax.durumrapor.com/app.php?action=GetPrice', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(vehicle),
          });
          const priceData = await priceRes.json();
          const tutar = parseFloat(priceData?.price) || 0;

          // Tahsilatı tamamla
          await fetch('https://mirwax.durumrapor.com/app.php?action=CompletePayment', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              vehicle,
              tutar,
              odeme_tipi: vehicle.OdemeTuru === 'NAKİT' ? 'Nakit' : 'Kredi Kartı',
              tarih,
            }),
          });

          // Her araç için socket emitleri
          if (socketRef?.current?.connected) {
            socketRef.current.emit('senk', { message: 'update' });
            socketRef.current.emit('senk', { message: 'Tahsilat', Plaka: vehicle.plate });
          }
        })
      );

      // Tümü bittikten sonra ReloadArabalar ve yenile
      if (socketRef?.current?.connected) {
        setTimeout(() => {
          socketRef.current.emit('from-python', { action: 'ReloadArabalar' });
        }, 500);
      }

      verileriYenile();
      setPersonelModalVisible(false);

      setTimeout(() => {
        setAlertConfig({
          visible: true,
          title: 'Başarılı',
          message: `${hedefAraclar.length} araç için tahsilat başarıyla tamamlandı.`,
          type: 'success',
          showCancel: false,
          confirmText: 'Tamam',
          onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false })),
        });
      }, 500);

    } catch (error) {
      console.log('Personel tahsilat hatası:', error);
      setAlertConfig({
        visible: true,
        title: 'Hata',
        message: 'Tahsilat sırasında bir hata oluştu.',
        type: 'error',
        showCancel: false,
        confirmText: 'Tamam',
        onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false })),
      });
    }
  };

  // 1. Kullanıcı butona bastığında çalışan Onay İsteme Fonksiyonu
  const handlePaymentConfirm = () => {
    setAlertConfig({
      visible: true,
      title: "Tahsilat Onayı",
      message: `*${selectedVehicle.plate}* plakalı araç için \n*${aracbilgisi.Fiyat} TL* tutarında \n*${paymentType}* ödeme alınacaktır. \n\nOnaylıyor musunuz?`,
      type: 'info', // Mavi bilgi ikonu
      showCancel: true,
      confirmText: "Evet, Onayla",
      cancelText: "Vazgeç",
      onConfirm: () => {
        // Alert'i kapat ve asıl ödeme işlemini başlat
        setAlertConfig(prev => ({ ...prev, visible: false }));
        executePayment(); // Gerçek API isteği
      }
    });
  };

// 2. Asıl Ödeme İşlemini Gerçekleştiren Fonksiyon
const executePayment = async () => {
  try {
    const response = await fetch('https://mirwax.durumrapor.com/app.php?action=CompletePayment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        vehicle: selectedVehicle,      // selectedVehicle komple JSON
        tutar: aracbilgisi.Fiyat,
        odeme_tipi: paymentType,
        tarih: new Date().toLocaleString('sv-SE').replace('T', ' ')
      })
    });

    
    const res = await response.json();
    console.log("Ödeme Ekranından Dönen Veri:", res);
    
    if (res.status === "ok" || res.status === "success") {


      if (socketRef && socketRef.current && socketRef.current.connected) {

        socketRef.current.emit("senk", {message: "update"}); // Ofisten Siliyor
        socketRef.current.emit("senk", {message: "Tahsilat",Plaka: selectedVehicle.plate}); // Kurulamadan Siliyor
        setTimeout(() => {
            socketRef.current.emit("from-python", {"action": "ReloadArabalar"});
        }, 500);
        console.log("Socket emit başarılı!");
        verileriYenile();
      } else {
          console.log("Socket bağlı değil, işlem yapıldı ama socket tetiklenemedi.");
      }


 
      
      setPaymentModalVisible(false); // Ana tahsilat modalını kapat
      
      // Başarı mesajını da CustomAlert ile gösterelim
      setTimeout(() => {
        setAlertConfig({
          visible: true,
          title: "Başarılı",
          message: "Tahsilat başarıyla kaydedildi.",
          type: 'success', // Yeşil onay ikonu
          showCancel: false,
          confirmText: "Tamam",
          onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false }))
        });
      }, 500); // Modal kapanma animasyonuyla çakışmaması için ufak bir gecikme
    }
  } catch (error) {
    console.log("CompletePayment HATA:", error);
    setAlertConfig({
      visible: true,
      title: "Hata",
      message: "Ödeme kaydedilemedi. Lütfen bağlantınızı kontrol edin.",
      type: 'error', // Kırmızı hata ikonu
      showCancel: false,
      onConfirm: () => setAlertConfig(prev => ({ ...prev, visible: false }))
    });
  }
};

const deleteVehicle = () => {
  setAlertConfig({
    visible: true,
    title: 'Emin misiniz?',
    message: `*${selectedVehicle.plate}* plakalı araç kalıcı olarak silinecektir.`,
    type: 'warning',
    showCancel: true,
    onConfirm: async () => {
       socketRef.current.emit("senk", {message: "DeletePlaka",Plaka: selectedVehicle.plate}); // Kurulamadan Siliyor
       socketRef.current.emit("senk", {message: "delete",plaka: selectedVehicle.plate}); // Kurulamadan Siliyor
       setAlertConfig(prev => ({ ...prev, visible: false }));
       setPaymentModalVisible(false); // Ana tahsilat modalını kapat
       verileriYenile();
    }
  });
};

  const formatTrTarih = (tarih) => {
    if (!tarih || tarih === "--:--") return tarih;

    // 1. Gelen veriyi parçalarına ayır (Örn: "2026-03-05 17:25:23")
    const parcalar = tarih.split(' ');
    const tarihKismi = parcalar[0]; // "2026-03-05"
    const saatKismi = parcalar[1] || ""; // "17:25:23"

    // 2. Bugünün tarihini al (YYYY-MM-DD formatında)
    const bugun = new Date().toISOString().slice(0, 10);

    // 3. Karşılaştırma yap
    if (tarihKismi === bugun) {
      // Eğer tarih bugüne aitse sadece saati döndür
      return saatKismi; 
    } else {
      // Eğer tarih bugün değilse tam tarih döndür (GG.AA.YYYY SAAT)
      const gunAyYil = tarihKismi.split('-');
      if (gunAyYil.length !== 3) return tarih;
      
      return `${gunAyYil[2]}.${gunAyYil[1]}.${gunAyYil[0]} ${saatKismi}`.trim();
    }
  };

  const formatPlaka = (plaka) => {
    if (!plaka) return "";

    // Önce tüm boşlukları temizle ve büyük harfe çevir
    const temizPlaka = plaka.replace(/\s+/g, "").toUpperCase();

    // Regex açıklaması: 
    // ([0-9]{2}) -> İlk 2 rakamı al (Şehir kodu)
    // ([A-Z]{1,3}) -> 1 ile 3 arasındaki harfleri al
    // ([0-9]{2,4}) -> Kalan rakamları al
    const match = temizPlaka.match(/^(\d{2})([A-Z]{1,3})(\d{2,4})$/);

    if (match) {
      return `${match[1]} ${match[2]} ${match[3]}`;
    }

    // Eğer format standart dışıysa (Örn: özel plakalar), olduğu gibi döndür
    return temizPlaka;
  };

  // Türkiye para formatına çeviren yardımcı fonksiyon
  const formatCurrency = (amount) => {
    if (!amount) return "0,00₺";
    return (
      amount
        .toFixed(2)                     // Önce 2 ondalık basamağa sabitle (Örn: 1250.50)
        .replace('.', ',')              // Ondalık ayracını virgüle çevir (Örn: 1250,50)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "₺" // Binlik ayraçlarına nokta ekle (Örn: 1.250,50 ₺)
    );
  };

  // --- RENDER CARD (Mevcut yapını koruduk) ---
  const renderCard = ({ item }) => (
  <TouchableOpacity 
    style={styles.card} 
    onPress={() => handleLongPress(item)} 
    delayLongPress={500}
  >
    <View>
      <View style={styles.headerRow}>
        <Text style={styles.plateText}>{formatPlaka(item.plate)}</Text>
        
        {/* Güncellenen Kısım */}
        <Text style={[
          styles.badgeText, 
          { 
            color: item.isPaid 
              ? 'green' 
              : (item.RemoteTahsilat === 'OK' ? 'orange' : 'red') 
          }
        ]}>
          {item.isPaid 
            ? 'TAHSİL EDİLDİ' 
            : (item.RemoteTahsilat === 'OK' 
                ? `${item.OdemeTuru ? item.OdemeTuru : ''}` 
                : 'BEKLİYOR')
          }
        </Text>
      </View>

      <View style={styles.divider} />
        <View style={styles.cardContent}>
          <View style={styles.row}>
            <Text style={styles.label}>Personel</Text>
            <Text style={styles.value}>: {item.personnel}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Kategori</Text>
            <Text style={styles.value}>: {item.category}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Hizmet</Text>
            <Text style={styles.value}>: {item.service}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Tarih</Text>
            <Text style={styles.value}>: {formatTrTarih(item.date)}</Text>
          </View>
        </View>
      </View>
  </TouchableOpacity>
  );

  return (
    <SafeAreaView style={styles.safeArea} edges={['top', 'left', 'right']}>
      
      <View style={styles.container}>
        
        {/* Üst Kısım: Araç Listesi */}
        <View style={styles.listContainer}>
          {vehicles.length === 0 ? (
            <Text onPress={onRefresh} style={styles.emptyText}>Henüz araç kaydı yok.</Text>
          ) : (
            <FlatList
              data={vehicles}
              keyExtractor={(item) => item.id}
              renderItem={renderCard}
              refreshing={refreshing}
              onRefresh={onRefresh}
            />
          )}
        </View>

        {/* Alt Kısım: Toplam Tutarlar */}
        <TouchableOpacity 
          style={styles.summaryContainer}
          onPress={() => setPersonelModalVisible(true)}
          activeOpacity={0.8}
        >
          <View style={[styles.summaryButton, styles.cashButton]}>
            <Text style={styles.summaryTitle}>Nakit</Text>
            <Text style={styles.summaryAmount}>{formatCurrency(nakitToplam)}</Text>
          </View>
          
          <View style={[styles.summaryButton, styles.cardButton]}>
            <Text style={styles.summaryTitle}>Kredi Kartı</Text>
            <Text style={styles.summaryAmount}>{formatCurrency(kartToplam)}</Text>
          </View>
        </TouchableOpacity>

      </View>

      <CustomAlert 
        {...alertConfig} 
        onCancel={() => setAlertConfig(prev => ({ ...prev, visible: false }))} 
     />

     {/* --- PERSONEL ÖZET MODALI --- */}
    <WebModal
      visible={personelModalVisible}
      animationType="slide"
      onRequestClose={() => setPersonelModalVisible(false)}
    >
        <View style={styles.modalOverlay}>
          <View style={styles.paymentContent}>

            <TouchableOpacity 
              style={styles.closeButton} 
              onPress={() => setPersonelModalVisible(false)}
            >
              <Ionicons name="close-circle" size={32} color="#94a3b8" />
            </TouchableOpacity>

            <Text style={styles.modalTitle}>Personel Özeti</Text>

              {Object.keys(personelOzetleri).length === 0 ? (
                <Text style={{ textAlign: 'center', color: '#999', marginVertical: 20 }}>
                  Henüz tahsilat kaydı yok.
                </Text>
              ) : (
                <>
                {/* Tablo Başlığı */}


                {/* Personel Satırları - Kart Tasarımı */}
                {Object.entries(personelOzetleri)
                  .sort((a, b) => (b[1].nakit + b[1].kart) - (a[1].nakit + a[1].kart))
                  .map(([ad, ozet]) => (
                    <View key={ad} style={personelStyles.personelKart}>
                      
                      {/* Personel Adı */}
                      <Text style={personelStyles.personelAd}>{ad}</Text>
                      
                      {/* 3 Kutu: Nakit | Kart | Toplam */}
                      <View style={personelStyles.kutular}>

                        {/* NAKİT KUTUSU */}
                        <TouchableOpacity
                          style={[personelStyles.kutu, { backgroundColor: '#f0fdf4' }]}
                          onPress={() => handlePersonelTahsilat(ad, 'NAKİT')}
                          activeOpacity={0.7}
                        >
                          <Text style={personelStyles.kutuBaslik}>Nakit</Text>
                          <Text style={[personelStyles.kutuTutar, { color: '#10b981' }]}>
                            {formatCurrency(ozet.nakit)}
                          </Text>
                        </TouchableOpacity>

                        {/* KREDİ KARTI KUTUSU */}
                        <TouchableOpacity
                          style={[personelStyles.kutu, { backgroundColor: '#eff6ff' }]}
                          onPress={() => handlePersonelTahsilat(ad, 'KREDİ KARTI')}
                          activeOpacity={0.7}
                        >
                          <Text style={personelStyles.kutuBaslik}>Kart</Text>
                          <Text style={[personelStyles.kutuTutar, { color: '#3b82f6' }]}>
                            {formatCurrency(ozet.kart)}
                          </Text>
                        </TouchableOpacity>

                        {/* TOPLAM KUTUSU - tıklanamaz */}
                        <View style={[personelStyles.kutu, { backgroundColor: '#f8fafc' }]}>
                          <Text style={personelStyles.kutuBaslik}>Toplam</Text>
                          <Text style={[personelStyles.kutuTutar, { color: '#334155' }]}>
                            {formatCurrency(ozet.nakit + ozet.kart)}
                          </Text>
                        </View>

                      </View>
                    </View>
                ))}

              {/* Genel Toplam */}
              <View style={personelStyles.genelToplam}>
                <View style={[personelStyles.kutu, { backgroundColor: '#dcfce7' }]}>
                  <Text style={personelStyles.kutuBaslik}>Nakit</Text>
                  <Text style={[personelStyles.kutuTutar, { color: '#10b981', fontWeight: 'bold' }]}>
                    {formatCurrency(nakitToplam)}
                  </Text>
                </View>
                <View style={[personelStyles.kutu, { backgroundColor: '#dbeafe' }]}>
                  <Text style={personelStyles.kutuBaslik}>Kart</Text>
                  <Text style={[personelStyles.kutuTutar, { color: '#3b82f6', fontWeight: 'bold' }]}>
                    {formatCurrency(kartToplam)}
                  </Text>
                </View>
                <View style={[personelStyles.kutu, { backgroundColor: '#e2e8f0' }]}>
                  <Text style={personelStyles.kutuBaslik}>Toplam</Text>
                  <Text style={[personelStyles.kutuTutar, { color: '#334155', fontWeight: 'bold' }]}>
                    {formatCurrency(nakitToplam + kartToplam)}
                  </Text>
                </View>
              </View>



              </>
            )}
          </View>
        </View>
    </WebModal>

      {/* --- TAHSİLAT MODALI --- */}
    <WebModal visible={paymentModalVisible} animationType="slide">
      <View style={styles.modalOverlay}>
        <View style={styles.paymentContent}>

          <TouchableOpacity style={styles.closeButton} onPress={() => setPaymentModalVisible(false)}>
            <Ionicons name="close-circle" size={32} color="#94a3b8" />
          </TouchableOpacity>

          <Text style={styles.modalTitle}>{selectedVehicle?.plate}</Text>
          
          <View style={styles.priceContainer}>
            {loadingPrice ? (
              <ActivityIndicator color="#2563eb" />
            ) : (
              <TextInput
                style={styles.priceInput}
                value={String(aracbilgisi.Fiyat)}
                onChangeText={(v) =>
                  setaracbilgisi((prev) => ({
                    ...prev,
                    Fiyat: Number(v) || 0,
                  }))
                }
                keyboardType="numeric"
              />
            )}
            <Text style={styles.currency}>₺</Text>
          </View>

          <Text style={styles.label}>Ödeme Yöntemi</Text>
          <View style={styles.paymentMethods}>
            {['Nakit', 'Kredi Kartı'].map((type) => (
              <TouchableOpacity 
                key={type}
                style={[styles.methodBtn, paymentType === type && styles.methodBtnActive]}
                onPress={() => setPaymentType(type)}
              >
                <Text style={[styles.methodText, paymentType === type && styles.methodTextActive]}>{type}</Text>
              </TouchableOpacity>
            ))}
          </View>

          <TouchableOpacity 
            style={styles.confirmBtn} 
            onPress={handlePaymentConfirm}
          >
            <Text style={styles.confirmBtnText}>ÖDEMEYİ TAMAMLA</Text>
          </TouchableOpacity>

          <TouchableOpacity onPress={deleteVehicle} style={styles.fullDeleteButton} activeOpacity={0.7}>
            <Ionicons name="trash-outline" size={20} color="white" />
            <Text style={styles.fullDeleteButtonText}>KAYDI SİL / İPTAL ET</Text>
          </TouchableOpacity>

        </View>
      </View>
    </WebModal>
    </SafeAreaView>
  );
}

// --- STYLES ---
const styles = StyleSheet.create({
  safeArea: { flex: 1 },
  container: { flex: 1, padding: 20, backgroundColor: '#f4f4f4' },
  listContainer: { flex: 1 }, // YENİ: Listenin ana alanı esnekçe kaplaması için
  emptyText: { textAlign: 'center', marginTop: 50, color: '#999' },
  
  // Card Styles
  card: { backgroundColor: 'white', padding: 15, borderRadius: 10, marginBottom: 10, elevation: 2 },
  headerRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 0 },
  plateText: { fontSize: 19, fontWeight: 'bold', color: '#3779b6' },
  badgeText: { fontSize: 19, fontWeight: 'bold', color: '#8f3c5d' },
  cardContent: { paddingVertical: 8 },
  row: { flexDirection: 'row', marginBottom: 4, alignItems: 'center' },
  label: { width: 80, fontSize: 14, color: '#666', fontWeight: 'bold' }, // Çift tanımlama birleştirildi
  value: { flex: 1, fontSize: 14, fontWeight: 'bold', color: '#000' },
  divider: { height: 1, backgroundColor: '#eee', marginVertical: 10 }, // Çift tanımlama birleştirildi
  
  // Modal Styles
  modalOverlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.6)', justifyContent: 'center', padding: 20 },
  paymentContent: { 
    backgroundColor: 'white', 
    borderRadius: 24, 
    padding: 15, 
    paddingTop: 50, 
    position: 'relative',
    width: '100%',        // YENİ
    maxWidth: 500,        // YENİ - masaüstünde çok geniş olmasın
  },
  closeButton: { position: 'absolute', right: 15, top: 15, zIndex: 10 },
  modalTitle: { fontSize: 40, fontWeight: 'bold', textAlign: 'center', marginBottom: 20 },
  priceContainer: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f1f5f9', padding: 15, borderRadius: 12, marginBottom: 20 },
  priceLabel: { marginRight: 10, color: '#64748b' },
  priceInput: { fontSize: 24, fontWeight: 'bold', color: '#2563eb', minWidth: 60, textAlign: 'center' },
  currency: { fontSize: 20, marginLeft: 5, fontWeight: 'bold' },
  paymentMethods: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 25 },
  methodBtn: { flex: 1, padding: 10, borderWidth: 1, borderColor: '#e2e8f0', borderRadius: 10, marginHorizontal: 2, alignItems: 'center' },
  methodBtnActive: { backgroundColor: '#2563eb', borderColor: '#2563eb' },
  methodText: { fontSize: 11, fontWeight: 'bold', color: '#64748b' },
  methodTextActive: { color: 'white' },
  confirmBtn: { backgroundColor: '#22c55e', padding: 18, borderRadius: 15, alignItems: 'center', marginBottom: 12, elevation: 2 },
  confirmBtnText: { color: 'white', fontWeight: '800', fontSize: 16, letterSpacing: 0.5 },
  fullDeleteButton: { backgroundColor: '#fee2e2', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingVertical: 14, borderRadius: 15, borderWidth: 1, borderColor: '#fecaca', marginTop: 8 },
  fullDeleteButtonText: { color: '#ef4444', fontWeight: '700', fontSize: 13, marginLeft: 8 },
  cancelText: { textAlign: 'center', marginTop: 15, color: '#94a3b8' },

  // --- YENİ: Alt Toplam (Nakit / Kart) Buton Stilleri ---
  summaryContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10, // Listeyle arasına biraz boşluk açmak için
  },
  summaryButton: {
    flex: 1,
    paddingVertical: 16,
    borderRadius: 15, // Mevcut butonlarına uyumlu bir kavis
    alignItems: 'center',
    justifyContent: 'center',
    elevation: 3, // Android için hafif gölge
    shadowColor: '#000', // iOS için hafif gölge
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  cashButton: {
    backgroundColor: '#10b981', // Mevcut confirmBtn yeşiline yakın, modern bir ton
    marginRight: 15, // Kart butonuyla arasındaki boşluk
  },
  cardButton: {
    backgroundColor: '#3b82f6', // Mevcut priceInput mavisine yakın, modern bir ton
  },
  summaryTitle: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 4,
  },
  summaryAmount: {
    color: '#ffffff',
    fontSize: 19, // Rakamları biraz daha vurgulu yaptık
    fontWeight: 'bold',
  },
});

const personelStyles = StyleSheet.create({
  personelKart: {
    backgroundColor: '#fff',
    borderRadius: 14,
    padding: 14,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#e2e8f0',
    elevation: 1,
  },
personelAd: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#1e293b',
    marginBottom: 10,
    letterSpacing: 0.5,
    textAlign: 'center',  // YENİ
  },
  kutular: {
    flexDirection: 'row',
    gap: 8,
  },
  kutu: {
    flex: 1,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 6,
    alignItems: 'center',
  },
  kutuBaslik: {
    fontSize: 14,  // Nakit/Kart/Toplam - büyük
    color: '#64748b',
    fontWeight: '700',
    marginBottom: 4,
  },
  kutuTutar: {
    fontSize: 11,  // Tutar - küçük
    fontWeight: '600',
  },
  genelToplam: {
    flexDirection: 'row',
    gap: 8,
    marginTop: 4,
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: '#e2e8f0',
  },
});